export const getQueryParamOverrides = (experimentBucketString: string) => {
  const queryString = experimentBucketString.split('_')
  const expBucket = queryString.pop()
  const expName = queryString.join('_')
  return {
    expBucket,
    expName,
  } as {
    expBucket: string
    expName: string
  }
}
